// @ts-nocheck
import React, { Component } from 'react'
import { Col, Label, Row } from 'reactstrap'
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { observer } from 'mobx-react'
import ModalForm from '../../../comum/components/ModalForm'
import LoadingImage from '../../../comum/components/LoadingImage';
import { formatarDataCustomHTML } from '../../../../utils/formatar';

@observer
export default class ModalDetalhes extends Component {

    constructor(props) {

        super(props)

        this.controller = this.props.controller
    }

    render() {
        
        return (
            <ModalForm
                className="modal-detalhes-orcamento"
                esconderSalvar={true}
                labelCancelar="FECHAR"
                onClickCancelar={() => this.controller.toggleModal(null, null, "detalhes", false)}
            >
                {
                    this.controller.loadingDetalhe
                    ?<Row><Col><LoadingImage /></Col></Row>
                    :<React.Fragment>
                        <Row>
                            <Col className="cabecalho">
                                <h2>Detalhes do orçamento</h2>
                                <Label className="situacao-btn px-2 tag">{this.controller.formatTipo(this.controller.row.TipoOrcamento)}</Label>
                            </Col>
                            <Col>
                                <div className="float-right pl-4 informacoes">
                                    <Label>
                                        Acesso
                                    </Label>
                                    <div>
                                        {formatarDataCustomHTML(this.controller.row.DtOrcamento)}
                                    </div>
                                </div>
                                <div className="float-right pl-4 informacoes">
                                    <Label>
                                        Usuário
                                    </Label>
                                    <div>
                                        {this.controller.row.UsuarioOrcamento}
                                    </div>
                                </div>
                            </Col>
                                {
                                    this.controller.row.Status === 'C' &&
                                    <div className="pr-3">
                                        <div className="float-right pl-4 informacoes">
                                            <Label>
                                                Cancelamento
                                            </Label>
                                            <div>
                                                {formatarDataCustomHTML(this.controller.row.DtCancelamento)}
                                            </div>
                                        </div>
                                        <div className="float-right pl-4 informacoes">
                                            <Label>
                                                Cancelado por
                                            </Label>
                                            <div>
                                                {this.controller.row.UsuarioCancelamento}
                                            </div>
                                        </div>
                                    </div>
                                }
                        </Row>
                        <div>
                            <ToolkitProvider
                                keyField="OsId"
                                data={[...this.controller.listaDetalhe]}
                                columns={[...this.controller.colunasDetalhes]}
                            >
                                {
                                    props => <div className="tabela-detalhes">
                                        <div className="tabela-detalhes__conteudo">
                                            <BootstrapTable boostrap4
                                                stripped
                                                bordered={false}
                                                classes="tabela tabela-layout cabotagem"
                                                {...props.baseProps}
                                            />
                                        </div>
                                    </div>
                                }
                            </ToolkitProvider>
                        <Row className="info-rodape mx-0 pt-2">
                            <Col>
                                <div className="label">
                                    Nº Documento
                                </div>
                                <div>
                                    {this.controller.detalhesData.Documento}
                                </div>
                            </Col>
                            <Col>
                                <div className="float-right">
                                    <div className="label">
                                        Total a pagar
                                    </div>
                                    <div>
                                        {this.controller.detalhesData && !isNaN(parseFloat(this.controller.detalhesData.TotalPagar)) && this.controller.detalhesData.TotalPagar.toLocaleString('pt-BR',{style:'currency', currency:'BRL', minimumFractionDigits:2})}
                                    </div>

                                </div>
                            </Col>
                        </Row>
                        </div>
                        <div className="rodape-detalhes my-4">
                            <span className="rodape-detalhes__valor">{this.controller.listaDetalhe.length}</span> Serviço{this.controller.listaDetalhe.length > 1 ? "s" : ""}
                        </div>
                    </React.Fragment>
                }
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/consulta/components/ModalDetalhes.js